import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden"]

  connect() {
    this.inputTargets.forEach((input, index) => {
      input.addEventListener('keydown', (e) => this.handleKeyDown(e, index))
      input.addEventListener('input', (e) => this.handleInput(e, index))
      input.addEventListener('paste', (e) => this.handlePaste(e))
    })
  }

  handleKeyDown(e, index) {
    if (e.key === "Backspace" && e.target.value === "") {
      if (index > 0) {
        this.inputTargets[index - 1].focus()
      }
    } else if (e.key === "ArrowLeft") {
      if (index > 0) this.inputTargets[index - 1].focus()
    } else if (e.key === "ArrowRight") {
      if (index < this.inputTargets.length - 1) this.inputTargets[index + 1].focus()
    }
  }

  handleInput(e, index) {
    const value = e.target.value
    if (value.length > 1) {
      // Keep only the last typed character in case they type quickly
      e.target.value = value.charAt(value.length - 1)
    }

    if (value !== "" && index < this.inputTargets.length - 1) {
      this.inputTargets[index + 1].focus()
    }

    this.updateHidden()
  }

  handlePaste(e) {
    e.preventDefault()
    const paste = (e.clipboardData || window.clipboardData).getData('text')
    const match = paste.match(/\d/g)
    
    if (match) {
      const digits = match.slice(0, 4)
      digits.forEach((digit, i) => {
        if (this.inputTargets[i]) {
          this.inputTargets[i].value = digit
        }
      })
      
      const lastFilledIndex = Math.min(digits.length, 4) - 1
      if (lastFilledIndex >= 0 && lastFilledIndex < 3) {
        this.inputTargets[lastFilledIndex + 1].focus()
      } else if (lastFilledIndex === 3) {
        this.inputTargets[3].blur()
      }
      
      this.updateHidden()
    }
  }

  updateHidden() {
    const otp = this.inputTargets.map(i => i.value).join('')
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = otp
    }
  }
}
